import { ROUTE_POSITION_PATH } from 'routes';
import {
  Clipboard, LineChart, Award, User,
} from 'lucide-react';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { ROLE_INVESTOR } from 'constants/roles';

const usePositionRows = (rolePath) => {
  const user = useSelector(state => state.i18n.user);
  const literals = useSelector(state => state.i18n.literals.leftMenu);

  const navRows = useMemo(() => (rolePath === 'my-position' ? {
    upper: [
      {
        path: ROUTE_POSITION_PATH.PORTFOLIO,
        to: ROUTE_POSITION_PATH.PORTFOLIO,
        name: literals.portfolio,
        icon: Clipboard,
      },
      {
        path: ROUTE_POSITION_PATH.ANALYSIS,
        to: ROUTE_POSITION_PATH.ANALYSIS,
        name: literals.analysis,
        icon: LineChart,
      },
      {
        path: ROUTE_POSITION_PATH.OPPORTUNITIES,
        to: ROUTE_POSITION_PATH.OPPORTUNITIES,
        name: literals.opportunities,
        icon: Award,
      },
      {
        canView: user?.role.includes(ROLE_INVESTOR),
        path: ROUTE_POSITION_PATH.EDIT_INVESTOR,
        to: ROUTE_POSITION_PATH.EDIT_INVESTOR,
        name: literals.profile,
        icon: User,
      },
    ],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  } : {}), [rolePath, user?.POSITION?.id]);

  return navRows;
};

export default usePositionRows;
